const monthNames = [
  "जनवरी",
  "फरवरी",
  "मार्च",
  "अप्रैल",
  "मई",
  "जून",
  "जुलाई",
  "अगस्त",
  "सितम्बर",
  "अक्टूबर",
  "नवम्बर",
  "दिसम्बर",
];

export const monthNameMap = {
  january: "जनवरी",
  february: "फरवरी",
  march: "मार्च",
  april: "अप्रैल",
  may: "मई",
  june: "जून",
  july: "जुलाई",
  august: "अगस्त",
  september: "सितम्बर",
  october: "अक्टूबर",
  november: "नवम्बर",
  decemeber: "दिसम्बर",
};

export const getHindiMonthName = (date) => {
  return monthNames[new Date(date).getMonth()];
};

export const getDate = (date) => {
  return new Date(date).getDate();
};

export const getYear = (date) => {
  return new Date(date).getFullYear();
};

export const getTime = (date) => {
  return new Date(date).toLocaleTimeString("en-US", {
    hour12: true,
    hour: "numeric",
    minute: "numeric",
  });
};

export const getFormattedHindiDate = (date) => {
  return `${getDate(date)} ${getHindiMonthName(date)} ${getYear(date)}`;
};

export const getFormattedHindiDateTime = (date) => {
  return `${getDate(date)} ${getHindiMonthName(date)} ${getTime(date)}`;
};
